<template>
  <DefaultLayout v-show="render">
    <router-view></router-view>
  </DefaultLayout>
</template>

<script>
export default {
  data() {
    return {
      render:false,
    }
  },
  beforeCreate() {
    var selection = document.querySelector("#app") !== null;
    if (selection) {
      document.querySelector("#app").style["display"] = 'none'
    }
  },
  beforeMount(){
    let alreadyStoreFeatureList = this.$store.getters.getByKey(
        "adminFeatureList"
    );
    if(alreadyStoreFeatureList){
      this.render = true
      return
    }
    this.makeRequest('post', 'v1/get-admin-dashboard-feature', {}, {}, false,false).then(callResponse => {

      if (!callResponse.error) {
        let code = callResponse.response.data.code;

        if (code == 200) {
          let data = {
            data: callResponse.response.data.data,
            key: "adminFeatureList"
          };
          this.$store.dispatch("set", data);
          this.render = true
        }
        // else{
        //   this.$router.push({name :'login'})
        // }
        // document.querySelector("#app").removeAttribute('style');
      }
    });



  },
}
</script>

